import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { State } from 'types/Store';
import { User } from 'types/User';

const initialState = {
  role: undefined,
};

export const user = createSlice( {
  name: 'user',
  initialState,
  reducers: {
    updateUserToken: ( state: User, action: PayloadAction<Partial<string>> ) => {
      state.accessToken = action.payload;
    },
    updateUserAccount: ( state: User, action: PayloadAction<Partial<string>> ) => {
      state.account = action.payload;
    },
    updateUserRole: ( state: User, action: PayloadAction<Partial<string>> ) => {
      state.role = action.payload;
    },
    updateUserId: ( state: User, action: PayloadAction<Partial<string>> ) => {
      state.userId = action.payload;
    },
    updateUserEmail: ( state: User, action: PayloadAction<Partial<string>> ) => {
      state.email = action.payload;
    },
    logoutUser: () => ( initialState ),
  },
} );

export const {
  updateUserId,
  updateUserToken,
  updateUserAccount,
  updateUserRole,
  updateUserEmail,
  logoutUser,
} = user.actions;

export const selectUser = ( state: State ) => state.user;

export const selectUserAccount = ( state: State ) => state.user?.account;
export const selectUserRole = ( state: State ) => state.user?.role;

export default user.reducer;
